<template>
  <div>
    <div class="card card-shadow card-rounded border-0 mb-4" v-if="emailSending">
      <div class="card-body text-center">
        <spinner></spinner>
      </div>
    </div>
    <validation-observer ref="form" v-else>
      <div class="card card-shadow card-rounded border-0 mb-4">
        <div v-if="errors.length > 0" class="alert alert-danger">
          <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
        </div>
        <validation-provider vid="email" rules="required|email" v-slot="{ errors }">
          <div class="card-body">
            <template v-if="showEmailForm">
              <div class="small card-title font-weight-bold">{{ cardTitle || $t('ContractSendPage.cardTitle') }}</div>
              <div class="form-group email-form">
                <label for="userEmail" class="sr-only">{{ $t('ContractSendPage.email') }}</label>
                <input type="text"
                       id="userEmail"
                       class="form-control form-control-lg"
                       :class="{'is-invalid': errors.length}"
                       inputmode="email"
                       :placeholder="$t('ContractSendPage.placeholder')"
                       v-model="email"
                       :disabled="disabledEmail"
                >
                <span class="invalid-feedback" v-if="errors.length">{{ errors[0] }}</span>
              </div>
              <button id="button-send-contract-to-email" class="btn btn-primary btn-lg btn-block" @click="send()">
                {{ $t('ContractSendPage.sendButton') }}
              </button>
            </template>
            <template v-if="showDownloadLink">
              <hr class="my-4" v-if="showEmailForm"/>
              <div id="contract-download-description" class="text-muted text-center my-3" v-if="showEmailForm">
                {{ downloadDescription || $t('ContractSendPage.downloadDescription') }}
              </div>
              <button id="button-download-contract" class="btn btn-outline-primary btn-lg btn-block" @click="download" :disabled="downloadInitiated">
                <template v-if="downloadInitiated">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </template>
                <template v-else>
                  {{ $t('ContractSendPage.download') }}
                </template>
              </button>
            </template>
          </div>
        </validation-provider>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import store from '@shared/store'
import settings from '@shared/settings'

export default {
  props: ['isDownloadable', 'onDownload', 'emailEndpoint', 'cardTitle', 'downloadDescription'],
  data() {
    return {
      errors: [],
      email: store.state.currentUser.email || '',
      emailSending: false,
      reference: this.$route.params.reference,
      downloadInitiated: false
    }
  },
  computed: {
    showDownloadLink() {
      return settings.isDownloadContractsSupported() && this.isDownloadable
    },
    showEmailForm() {
      if (!this.$configuration.newCoreEnabled) {
        return true
      }
      return !!this.email
    },
    disabledEmail() {
      return this.$configuration.newCoreEnabled && !!this.email
    }
  },
  methods: {
    sendToEmail() {
      this.emailSending = true
      this.errors = []
      return this.$http.post(this.emailEndpoint, { email: this.email })
          .then(() => {
            this.$successToast(this.$t('ContractSendPage.wasSent.title'), this.$t('ContractSendPage.wasSent.message'))
            this.emailSending = false
            this.$emit('agreement-sent')
          })
          .catch((error) => {
            this.emailSending = false
            this.showSigningError(error)
          })
    },
    showSigningError: function (e) {
      if (e && e.response && e.response.data) {
        this.errors = e.response.data.errors || []
        if (e.response.data.reason === 'alreadySigned') {
          this.$errorToast(this.$t(`errors.${e.response.data.reason}.title`), this.$t(`errors.${e.response.data.reason}.content`))
        } else {
          this.$errorToast(this.$t('errors.technical.title'), this.$t('errors.technical.content'))
        }
      }
      throw e
    },
    send() {
      return this.$refs.form.validate().then(this.onValidationDone)
    },
    async download() {
      this.downloadInitiated = true
      this.onDownload()
          .then(() => {
            setTimeout(() => { this.$emit('agreement-sent') }, 1000)
          })
          .finally(() => {
            setTimeout(() => { this.downloadInitiated = false }, 1000)
          })
    },
    onValidationDone(isSuccess) {
      if (isSuccess) {
        this.sendToEmail()
      }
    }
  }
}
</script>
